import React from 'react';
import type { PercentileLevel } from '@talentmesh/utils';
import { Aspect } from '@/Models/Aspect';
import { progressColClass } from './PersonalityCharacteristicConsts';
import PersonalityCharacteristicAspects from './PersonalityCharacteristicAspects';
import PersonalityCharacteristicsToolTip from './PersonalityCharacteristicsToolTip';

interface PersonalityCharacteristicAspectTooltipProps {
    characteristicName: string;
    percentileScore: number;
    percentileLevel: PercentileLevel;
    aspects: Aspect[];
}

function PersonalityCharacteristicAspectTooltip({
    characteristicName,
    percentileScore,
    percentileLevel,
    aspects,
}: PersonalityCharacteristicAspectTooltipProps): React.JSX.Element {
    return (
        <div className={`${progressColClass} px-2`}>
            <PersonalityCharacteristicsToolTip
                hidden={percentileLevel === 'Medium' || aspects.length === 0}
                percentileScore={percentileScore}
                percentileLevel={percentileLevel}
            >
                <PersonalityCharacteristicAspects characteristicName={characteristicName} aspects={aspects} />
            </PersonalityCharacteristicsToolTip>
        </div>
    );
}

export default PersonalityCharacteristicAspectTooltip;
